export default __webpack_public_path__ + "static/media/Whatsapp.b44ca1ab.png";